
<template>
  <!-- 无权限 不能访问的展示组件 -->
  <div class="no-access">
    <component :is="getComponent"></component>
  </div>
</template>

<script>
import accessForm from './access-form'
import accessEmail from './access-email'
import accessMessenger from './access-messenger'
import accessGoogleAds from './access-google-ads'
import accessGoogleAdsLang from './access-google-ads-lang'
import accessFacebookAds from './access-facebook-ads'
import accessFacebookEffect from './access-facebook-effect'
import accessWebsite from './access-website'
export default {
  name: 'noAccess',
  components: {
    accessForm,
    accessEmail,
    accessMessenger,
    accessGoogleAds,
    accessFacebookAds,
    accessFacebookEffect,
    accessWebsite,
    accessGoogleAdsLang
  },
  props: {
    name: String,
  },
  computed: {
    getComponent () {
      const prefix = 'access';
      const permissionPageBlock = [
        {
          name: /表单询盘/,
          component: 'Form'
        },
        {
          name: /邮件询盘/,
          component: 'Email'
        },
        {
          name: /messenger询盘/,
          component: 'Messenger'
        },
        {
          name: /Google Ads广告/,
          component: 'GoogleAds'
        },
        {
          name: /小语种/,
          component: 'GoogleAdsLang'
        },
        {
          name: /Facebook Ads/,
          component: 'FacebookAds'
        },
        {
          name: /Facebook成效/,
          component: 'FacebookEffect'
        },
        {
          name: /网站统计/,
          component: 'Website'
        },

      ]
      const obj = permissionPageBlock.find(item => item.name.test(this.name))
      if (obj&&obj.component) return `${prefix}${obj.component}`

    }
  }
}
</script>

<style lang="scss">
</style>